import React from "react";
import "../../../css/Turismo/turismo.css";
import "../../../css/Turismo/recorre-oliva.css";

const RecorreOliva = () => (
  <section className="imagenes-ciudad" id="recorre-oliva">
    <h3><strong>Recorré</strong> Oliva</h3>
    <div className="row">
      <section className="col-12 col-md-7">
        <div className="card">
          <a className="image-container" href="https://www.munam.org.ar/" target="_blank" rel="noopener noreferrer">
            <img src={require("../../img/Museo2.jpeg")} alt="MUNAM" />
            <div className="overlay"></div>
            <div className="text-container">
              <h2 style={{ fontSize: 30 }}>MUNAM</h2>
              <span style={{ fontSize: 18 }} className="text-white">Ver más +</span>
            </div>
          </a>
        </div>
      </section>
      <section className="col-12 col-md-5">
        <div className="card">
          <a className="image-container" href="/plazas">
            <img src={require("../../img/Plaza-San-Martin.jpeg")} alt="Plazas" />
            <div className="overlay"></div>
            <div className="text-container">
              <h2 style={{ fontSize: 30, color: "white" }}>Plazas</h2>
              <span style={{ fontSize: 18 }} className="text-white">Ver más +</span>
            </div>
          </a>
        </div>
      </section>
      <section className="col-12 col-md-5">
        <div className="card">
          <a className="image-container" href="/pasajes-y-paseos">
            <img src={require("../../img/Av-Olmos1.jpeg")} alt="Pasajes y paseos" />
            <div className="overlay"></div>
            <div className="text-container">
              <h2 style={{ fontSize: 30, color: "white" }}>Pasajes y paseos de nuestra ciudad</h2>
              <span style={{ fontSize: 18 }} className="text-white">Ver más +</span>
            </div>
          </a>
        </div>
      </section>
      <section className="col-12 col-md-7">
        <div className="card">
          <a className="image-container" href="/lugares-para-visitar">
            <img src={require("../../img/Palacio-Municipal.jpeg")} alt="Lugares para visitar" />
            <div className="overlay"></div>
            <div className="text-container">
              <h2 style={{ fontSize: 30, color: "white" }}>Lugares para visitar</h2>
              <span style={{ fontSize: 18, color: "white" }}>Ver más +</span>
            </div>
          </a>
        </div>
      </section>
      <section className="col-12">
        <div className="card">
          <a className="image-container" href="/el-jardin-de-las-lechuzas">
            <img src={require("../../img/portada-jardin-lechuza3.JPG")} alt="El jardín de las lechuzas" />
            <div className="overlay"></div>
            <div className="text-container">
              <h2 style={{ fontSize: 30, color: "white" }}>El jardín de las lechuzas</h2>
              <span style={{ fontSize: 18, color: "white" }}>Ver más +</span>
            </div>
          </a>
        </div>
      </section>
    </div>
  </section>
);

export default RecorreOliva;